import styled, { css } from 'styled-components';

// Import styles
import { customMinResponsive, size } from 'components/styles';

const WatermarkImage = styled.img`
	height: 3.8rem;
	filter: grayscale(${({ isContrast }) => (isContrast ? 1 : 0)});

	${customMinResponsive(
		size.medium,
		css`
			height: 6rem;
		`
	)}
`;

export default WatermarkImage;
